module.exports = __webpack_public_path__ + "static/img/pic-professional-team.a7191e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/home/assets/pic-professional-team.png
// module id = jLNm
// module chunks = 1